import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUnitats } from '../../hooks/useUnitats';
import { getUnitatName } from '../../utils/unitats';

import * as S from './CalendarUnitatSelection.styles';

const UNITATS = ['agrupament', 'cills', 'llids', 'rings', 'pics', 'trucs'] as const;

const CalendarUnitatSelection: FC = () => {
	const navigate = useNavigate();
	const { unitats } = useUnitats();

	const handleUnitatClick = (unitat: string) => {
		// Selecting a unitat in the initial screen also preselects agrupament
		// (events tagged AGR apply to every unitat); selecting AGR itself stays single.
		const pre = unitat === 'agrupament' ? unitat : `${unitat},agrupament`;
		navigate(`/calendari/veure?pre=${pre}`);
	};

	const handleAllClick = () => {
		navigate(`/calendari/veure`);
	};

	const getUnitatAbrev = (unitatKey: string): string => {
		if (unitatKey === 'agrupament') return 'AGR';
		const unitat = unitats?.find((u) => u.abreviacio.toLowerCase() === unitatKey);
		return unitat?.abreviacio || unitatKey.toUpperCase().slice(0, 4);
	};

	return (
		<S.SelectionContainer>
			<S.SelectionPageTitle>Calendari</S.SelectionPageTitle>

			<S.ButtonGrid>
				{UNITATS.map((unitat) => (
					<S.ButtonGridItem key={unitat}>
						<S.UnitatSelectionButton
							unitat={unitat}
							$variant="outline-fill"
							onClick={() => handleUnitatClick(unitat)}
							type="button"
						>
							<S.ButtonLabel>{getUnitatName(unitat)}</S.ButtonLabel>
							<S.ButtonSubLabel>{getUnitatAbrev(unitat)}</S.ButtonSubLabel>
						</S.UnitatSelectionButton>
					</S.ButtonGridItem>
				))}

				<S.ButtonGridItem>
					<S.AllUnitsButton $variant="outline-fill" onClick={handleAllClick} type="button">
						<S.ButtonLabel>Totes les unitats</S.ButtonLabel>
						<S.ButtonSubLabel>Veure tots</S.ButtonSubLabel>
					</S.AllUnitsButton>
				</S.ButtonGridItem>
			</S.ButtonGrid>
		</S.SelectionContainer>
	);
};

export default CalendarUnitatSelection;
